export default __webpack_public_path__ + "static/mock-1d6683baf5e8272d4660c4bc12403591.png";